<template>
    <div class="field">
        <div class="input-label" v-if="title">{{ title }}</div>
        <div class="field-wrapper">
            <input
                :type="type"
                :placeholder="placeholder"
                :value="value"
                :disabled="disabled"
                @input="$emit('input', $event.target.value)"
            />
            <div class="field-addon">
                <span class="field-addon__text" v-if="addon">{{ addon }}</span>
                <slot name="addon"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InputAddons",
    props: {
        type: {
            type: String,
            default: "text"
        },
        placeholder: String,
        disabled: {
            default: false
        },
        value: {},
        addon: String,
        title: String
    }
};
</script>

<style scoped lang="scss">
.field-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 100%;
    input {
        flex-grow: 1;
        padding: 6px 10px;
        background: #fff;
        font-size: 14px;
        outline: none;
        border: 1px solid #e5e5e5;
        text-align: right;
        max-width: 100%;
    }
}
.field-addon {
    /*width: 34px;*/
    height: 100%;
    display: flex;
    border: 1px solid #e5e5e5;
    border-left-width: 0;
    &__text {
        padding: 6px 10px;
        font-size: 14px;
        color: #7a7a7a;
        cursor: default;
    }
}
</style>
